/**
 * Anchor Menu Sticky Shadow
 * Adds shadow to paragraph when it becomes sticky
 */
(function () {
  'use strict';

  Drupal.behaviors.anchorMenuSticky = {
    attach: function (context) {
      const paragraphs = context.querySelectorAll('.paragraph--type--anchor-menu');
      
      if (!paragraphs.length) return;

      paragraphs.forEach((paragraph) => {
        // Create an observer to detect when sticky positioning activates
        const observer = new IntersectionObserver(
          ([entry]) => {
            // When the paragraph is stuck at the top
            if (entry.intersectionRatio < 1) {
              paragraph.classList.add('is-stuck');
            } else {
              paragraph.classList.remove('is-stuck');
            }
          },
          { 
            threshold: [1],
            rootMargin: '-1px 0px 0px 0px'
          }
        );

        observer.observe(paragraph);
      });
    }
  };

  /**
   * Anchor Menu Scroll Arrows
   * Handles horizontal scrolling when content overflows
   */
  Drupal.behaviors.anchorMenuScrollArrows = {
    attach: function (context) {
      const containers = context.querySelectorAll('.anchor-menu-scroll-container');
      
      if (!containers.length) return;

      containers.forEach((container) => {
        const list = container.querySelector('.anchor-menu__list');
        const leftArrow = container.querySelector('.anchor-menu__scroll-arrow--left');
        const rightArrow = container.querySelector('.anchor-menu__scroll-arrow--right');

        if (!list || !leftArrow || !rightArrow) return;

        // Function to check if content is scrollable
        const isScrollable = () => {
          return list.scrollWidth > list.clientWidth;
        };

        // Function to update arrow visibility based on scroll position
        const updateArrows = () => {
          const scrollable = isScrollable();
          const scrollLeft = list.scrollLeft;
          const maxScroll = list.scrollWidth - list.clientWidth;

          // Show/hide arrows based on whether content is scrollable
          if (!scrollable) {
            leftArrow.classList.remove('is-visible');
            rightArrow.classList.remove('is-visible');
            return;
          }

          // Show arrows if content is scrollable
          leftArrow.classList.add('is-visible');
          rightArrow.classList.add('is-visible');

          // Hide left arrow at start
          if (scrollLeft <= 5) {
            leftArrow.classList.add('is-hidden');
          } else {
            leftArrow.classList.remove('is-hidden');
          }

          // Hide right arrow at end
          if (scrollLeft >= maxScroll - 5) {
            rightArrow.classList.add('is-hidden');
          } else {
            rightArrow.classList.remove('is-hidden');
          }
        };

        // Initial check
        updateArrows();

        // Recheck after fonts load (fonts can affect width)
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            updateArrows();
          });
        } else {
          // Fallback for browsers without font loading API
          setTimeout(updateArrows, 100);
        }

        // Update on scroll
        list.addEventListener('scroll', updateArrows);

        // Update on resize
        window.addEventListener('resize', updateArrows);

        // Scroll on arrow click
        leftArrow.addEventListener('click', () => {
          list.scrollBy({
            left: -200,
            behavior: 'smooth'
          });
        });

        rightArrow.addEventListener('click', () => {
          list.scrollBy({
            left: 200,
            behavior: 'smooth'
          });
        });
      });
    }
  };
})(Drupal);